import axios from 'axios';
import { Notification } from 'element-ui';
import { GetAuthToken } from 'rj-server-auth-token';
import { readErrorBlob } from '../libs/util';
import Cookies from 'js-cookies';
import { getSign } from './requestEncryption';
let CreditFileAxios = axios.create();
// let querystring = require('querystring');
// 允许跨域请求发送cookie
CreditFileAxios.defaults.withCredentials = false;
CreditFileAxios.defaults.baseURL = `${window._env_.VUE_APP_REQUEST_ADDRESS}/`;
// axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? '/order-lifecycle-uat02' : '/order-lifecycle-uat02';
// axios.defaults.headers.post['Content-Type'] = 'application/json'; // application/x-www-form-urlencoded , multipart/form-data
// http请求拦截
CreditFileAxios.interceptors.request.use(
  config => {
    config.headers['web-sign-server-auth'] = GetAuthToken({
      sysId: '6ff2a8ed94de46aca1f5dc996169a424',
      accessKeySecret: '4D0E6C351B5740BE84960FEC53CC9E84'
    });
    config.headers['sysId'] = '6ff2a8ed94de46aca1f5dc996169a424';
    config.headers['timeOut'] = new Date().getTime();
    config.headers['sid_login'] = localStorage.getItem('sidLogin') && JSON.parse(localStorage.getItem('sidLogin') || '');
    config.headers['union_session_ticket'] = localStorage.getItem('union_session_ticket');

    let timestamp = localStorage.getItem('timestamp');
    if (timestamp && timestamp + 600000 > new Date().getTime()) {
      timestamp = new Date().getTime();
      localStorage.setItem('timestamp', timestamp);
    } else {
      timestamp = new Date().getTime();
    }
    const sign = getSign(config, axios, timestamp);
    config.headers['sign'] = sign;
    config.headers['timestamp'] = timestamp;

    return config;
  },

  error => {
    return Promise.reject(error);
  }
);

// http响应拦截器
CreditFileAxios.interceptors.response.use(
  async res => {
    let json = res.data;
    if (json.type === 'application/json') {
      const result = await readErrorBlob(json);
      if (result && result.status !== '200') {
        Notification.error({
          message: result.error || result.err
        });
        throw Promise.reject(result);
      }
    }
    return res;
  },
  error => {
    // Notification.error({
    //   message: '请求服务器失败'
    // });
    if (error.message.includes('428')) {
      Cookies.removeItem('ruijieportal', '/', '.ruijie.com.cn');
      Cookies.removeItem('PartnerUser', '/', '.ruijie.com.cn');
      Cookies.removeItem('phplogin', '/', '.ruijie.com.cn');
      Cookies.removeItem('thh_auth', '/', '.ruijie.com.cn');
      Cookies.removeItem('sid_login', '/', '.ruijie.com.cn');
      // 干掉切换的渠道
      Cookies.removeItem('xsyx_chang_user', '/', '.ruijie.com.cn');
      window.localStorage.removeItem('union_session_ticket');
      if (window._env_.NODE_ENV !== 'pro') {
        window.location.href = `${window.location.origin}/toLoginPage`;
      } else {
        window.location.href = `https://ces.ruijie.com.cn/toLoginPage`;
      }
      // return Notification.warning({
      //   message: '登录验证失败或登录已失效，请重新登录'
      // });
    }
    return Promise.reject(error);
  }
);
// axios 具体使用 请参考 https://github.com/axios/axios
export default CreditFileAxios;
